import type { PropsWithChildren } from 'react';
import BlurredBg from '@ab-inbev-eu/ui-library/components/basic/BlurredBg';
import { cn } from '@ab-inbev-eu/ui-library/components/utils';

import { useApplicationStore } from '../stores/application.store';

interface CampaignBackgroundProps extends PropsWithChildren {
  container?: {
    className?: string;
  };
}

export function CampaignBackground({ children, container }: CampaignBackgroundProps) {
  const campaign = useApplicationStore((state) => state.campaign);
  if (!campaign) return children;

  const backgroundColor =
    'background-color' in campaign.branding.colors ? (campaign.branding.colors['background-color'] as string) : null;
  if (backgroundColor) {
    return (
      <div
        className={cn(
          `absolute inset-0 size-full h-[100dvh] overflow-y-auto overflow-x-hidden bg-[rgb(var(--background-color))]`,
          container?.className,
        )}
        style={{ '--background-color': backgroundColor } as React.CSSProperties}
      >
        {children}
      </div>
    );
  }

  const backgroundImageUrl =
    'backgroundImageUrl' in campaign.branding.assets ? (campaign.branding.assets.backgroundImageUrl as string) : null;
  if (backgroundImageUrl) {
    return (
      <BlurredBg
        className={{
          container: container?.className,
        }}
      >
        {children}
      </BlurredBg>
    );
  }

  return children;
}
